import api from './../helpers/api'

class CustomerService {

    saveCustomer(customer) {
        return api.post('/save_customer', {
            name:         customer.name,
            address:      customer.address,
            contact:      customer.contact,
            email:        customer.email        || null,
            notes:        customer.notes        || null,
            credit_limit: customer.credit_limit || 0,
        });
    }

    editCustomer(customer) {
        return api.post('/edit_customer', {
            id:           customer.id,
            name:         customer.name,
            address:      customer.address,
            contact:      customer.contact,
            email:        customer.email        || null,
            notes:        customer.notes        || null,
            credit_limit: customer.credit_limit || 0,
        });
    }

    get_customerlist() {
        return api.get('/get_all_customers');
    }

    getProfile(id) {
        return api.get(`/customer_profile/${id}`);
    }

    updateCreditLimit(id, limit) {
        return api.post(`/update_credit_limit/${id}`, { credit_limit: limit });
    }

    redeemPoints(id, points) {
        return api.post(`/redeem_points/${id}`, { points });
    }

    payInvoice(saleId, amount, fromDeposit = 0) {
        return api.post(`/pay_invoice/${saleId}`, { amount, from_deposit: fromDeposit });
    }

    /** Clear outstanding invoices from the customer's deposit, oldest first. */
    settleFromDeposit(id, body = {}) {
        return api.post(`/customer_settle_from_deposit/${id}`, body);
    }

    getCustomerDebts(id) {
        return api.get(`/customer_debts/${id}`);
    }

    // Server-rendered PDFs (returned as a blob so the auth token is sent).
    printCustomerDebt(saleId) {
        return api.get(`/customer_debt/${saleId}/print`, { responseType: 'blob' });
    }

    printAllCustomerDebts(id) {
        return api.get(`/customer_debts/${id}/print`, { responseType: 'blob' });
    }

    // ── Deposits (store credit) ──────────────────────────────────────────────
    addDeposit(id, payload) {
        return api.post(`/customer_deposit/${id}`, payload);
    }

    getCustomerDeposits(id) {
        return api.get(`/customer_deposits/${id}`);
    }

    printDeposit(depositId) {
        return api.get(`/customer_deposit/${depositId}/print`, { responseType: 'blob' });
    }

    printAllDeposits(id) {
        return api.get(`/customer_deposits/${id}/print`, { responseType: 'blob' });
    }

    get_customer_purchase(id) {
        return api.get(`/get_customer_purchase/${id}`);
    }

    get_customer_purchases(range, id) {
        return api.post(`/get_customer_purchases/${id}`, { range });
    }

    get_customers() {
        return api.get('/get_customers');
    }

    get_customer(id) {
        return api.post('/get_customer', { id });
    }

    save(id, remain, amount) {
        return api.post(`/save_paid/${id}`, { remain, amount });
    }

    get_paid_customers() {
        return api.get('/get_paid_customers');
    }

    view_customer_payments(id) {
        return api.get(`/view_customer_payments/${id}`);
    }

    get_debts() {
        return api.get('/get_debts', {});
    }

    paid_debts() {
        return api.get('/paid_debts', {});
    }

    save_paid_debt(id, account, amount, remain) {
        return api.post('/save_paid_debt', { id, remain, amount, account });
    }

    save_debt(debt) {
        return api.post('/save_new_debt', {
            name:        debt.name,
            amount:      debt.amount,
            description: debt.description,
        });
    }

    editPayment(payment) {
        return api.post('/edit_customer_payment', { id: payment.id, amount: payment.amount });
    }

    get_purchase_balance() {
        return api.get('/get_purchase_balance');
    }

    save_purchase_balance(id, remain, amount) {
        return api.post(`/save_purchase_balance/${id}`, { remain, amount });
    }

    view_payed_purchases(id) {
        return api.post(`/view_payed_purchases/${id}`);
    }

    get_paid_purchase_balance() {
        return api.get('/get_paid_purchase_balance');
    }

    refund(id, sold_id, quantity) {
        return api.post(`/refund/${id}`, { sold_id, quantity });
    }

    deleteTransaction(sale_id, customer_id) {
        return api.post('/delete_transaction', { sale_id, customer_id });
    }

    customersSales(start, end) {
        return api.post('/custo_sales', { start, end });
    }
}

export default new CustomerService;
